import { faCircleArrowLeft, faCircleArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import mapboxgl, { LngLatLike } from "mapbox-gl";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMap } from "react-map-gl";
import { SearchPayload } from "../../../redux/actions/nbhd/search";
import { ResultObject, SearchResponse } from "../../../redux/reducers/getNBHDReducer/getSearchReducer";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import "./SearchResults.css";
import { useDispatch } from "react-redux";
import { setToastNotification } from "../../../redux/actions/toastNotification/toastNotification";

export interface SearchResultsProps {
    response: SearchResponse,
    resultsPayload: SearchPayload // payload correlating with results -> for paging
    pagerCallback: (newPayload: SearchPayload) => void; // callback for calling distpatch in parent,
    loading: boolean;
    cityCoords: object;
    handleViewChange: (e) => void;
}

export default function SearchResults(props: SearchResultsProps) {

    const { t } = useTranslation("nbhd");
    const page = props.response.page;
    const pages = props.response.pages;
    const propsResults = props.response.results
    const [results, setResults] = useState(propsResults);

    const { mainMap } = useMap();

    const dispatch = useDispatch();

    const marker = new Image(); // Image constructor
    marker.src = './images/Pins/orange_marker.png';
    marker.alt = '';

    const [currentMarker, setCurrentMaker] = useState<mapboxgl.Marker>(new mapboxgl.Marker(marker))

    const newPage = (page: number) => {
        props.pagerCallback({
            ...props.resultsPayload,
            page: Number(page)
        })
    }

    const [selectedRoll, setSelectedRoll] = useState<string | null>(null)
    
    useEffect(() => {
        if(props.cityCoords){
            let cityName = "";
            const newResults = results;
            newResults.forEach((address) => {
                if ((address.centroid.lat === null) || (address.centroid.lon === null)) {
                    if (address.city.includes('CITY OF')){
                        cityName = (address.city.replace('CITY OF ',''));
                    } else if (address.city.includes('NORTH ')){
                        cityName = (address.city);
                    } else if (address.city.includes('SOUTH ')){
                        cityName = (address.city);
                    } else if (address.city.includes('st. ')){
                        cityName = (address.city);
                    } else {
                        cityName = (address.city.substring(0, address.city.indexOf(' ')));
                    }
                    try {
                        address.centroid.lat = props.cityCoords[cityName][0];
                        address.centroid.lon = props.cityCoords[cityName][1];
                        address.noCentroid = true;
                    } catch {
                        console.error("FAILED TO GET NEAREST CITY"+ cityName)
                    }
                }
            });
            setResults(newResults)
        }
    }, [props.cityCoords, results])

    useEffect(() => {
        setResults(props.response.results)
    }, [props.response.results])

    return (
        <AmpLoadingSpinner loading={props.loading}>
            <div>
                <div className="results-div">
                    {results.map((value: ResultObject, index: number) => {
                        return (
                            <div key={index} className={`result-row ${selectedRoll === value.roll && "active"}`}
                                onClick={(e) => {
                                    if (mainMap) {
                                        // remvoe marker from map
                                        currentMarker.remove();
                                        const latLng = [value.centroid.lon, value.centroid.lat] as LngLatLike;
                                        value.noCentroid && dispatch(setToastNotification("No coordinates for given property, locating nearest city", "warning"));
                                        mainMap?.jumpTo({ center: latLng });
                                        // add marker back to map at new cords
                                        currentMarker.setLngLat(latLng).addTo(mainMap.getMap());
                                        setCurrentMaker(currentMarker);
                                        setSelectedRoll(value.roll);
                                        props.handleViewChange('MAP');
                                    }
                                }}
                                onDoubleClick={(e) => {
                                    if (value.centroid && mainMap) {
                                        currentMarker.remove();
                                        value.noCentroid && dispatch(setToastNotification("No coordinates for given property, locating nearest city", "warning"));
                                        mainMap?.jumpTo({ center: [value.centroid.lon, value.centroid.lat] }, { roll: value.roll });
                                    }
                                }}>
                                {value.address} - {value.city}
                            </div>
                        )
                    })}
                </div>
                <div className="num-results">
                    <div>
                        <span>{`${t("nbhd.search.view-page")} [ `}</span>
                        <span className="blue-page-num">{page}</span>
                        <span>{t("nbhd.search.page-of")}</span>
                        <span className="blue-page-num">{pages}</span>
                        <span>{` ]`}</span>
                    </div>
                </div>
                <div className="pager">
                    <div onClick={() => newPage(1)} className={page !== 1 ? "" : "nav-disabled"}>{"First"}</div>
                    <div onClick={() => newPage(page - 1)} className={(page - 1) >= 1 ? "" : "nav-disabled"}><FontAwesomeIcon icon={faCircleArrowLeft} /></div>
                    <div className="currentPage">{page}</div>
                    <div onClick={() => newPage(page + 1)} className={(page + 1) <= pages ? "" : "nav-disabled"}><FontAwesomeIcon icon={faCircleArrowRight} /></div>
                    <div onClick={() => newPage(pages)} className={page < pages ? "" : "nav-disabled"}>{`Last`}</div>
                </div>
            </div>
        </AmpLoadingSpinner>
    )
}